/* eslint-disable react-hooks/rules-of-hooks */

/* eslint-disable no-shadow */
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Switch,
  Textarea,
} from '@nextui-org/react';
import useMutation from '@simppl/react-query/useMutation';
import useQueryClient from '@simppl/react-query/useQueryClient';
import { badgeApi } from '@simppl/repository-admin/badge';
import { tutorApi } from '@simppl/repository-admin/tutor';
import { ApplicationStatusEnum } from '@simppl/repository-admin/tutor/res';
import { useState } from 'react';

type BadgeApplicationManageModalProps = {
  applicationId: string;
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  invalidateKeys: (string | number)[];
};

export const BadgeApplicationManageModal = ({
  applicationId,
  isOpen,
  onOpenChange,
  invalidateKeys,
}: BadgeApplicationManageModalProps) => {
  const [isApproved, setIsApproved] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');

  const approvalMutation = useMutation(badgeApi.APPLICATION.APPROVAL);
  const queryClient = useQueryClient();

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className='flex flex-col gap-1'>뱃지 신청 승인 관리</ModalHeader>
            <ModalBody>
              <div className='flex flex-col gap-4'>
                <div className='flex gap-4'>
                  <p>승인 여부</p>
                  <Switch
                    checked={isApproved}
                    onValueChange={setIsApproved}
                  />
                </div>
                <div className='flex flex-col'>
                  <p>반려 사유</p>
                  <Textarea
                    isDisabled={isApproved}
                    placeholder='반려 사유를 입력해주세요.'
                    value={rejectionReason}
                    onValueChange={setRejectionReason}
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color='danger'
                variant='light'
                onPress={onClose}
              >
                취소
              </Button>
              <Button
                type='submit'
                form='authorization'
                color='primary'
                onPress={() => {
                  if (!isApproved && !rejectionReason) {
                    alert('반려 사유를 입력해주세요');
                    return;
                  }
                  approvalMutation.mutate(
                    {
                      status: isApproved
                        ? ApplicationStatusEnum.APPROVED
                        : ApplicationStatusEnum.REJECTED,
                      rejectReason: isApproved ? '' : rejectionReason,
                      applicationId,
                    },
                    {
                      onSuccess: () => {
                        queryClient.invalidateQueries(invalidateKeys);
                        onClose();
                      },
                    },
                  );
                }}
              >
                저장
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
